import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'
import reward1_1Image from '../assets/rewards/reward1_1.jpg'

import './formular230.css'

if (typeof window !== 'undefined') {
  const yearEnv = process.env.REACT_APP_FORM230_SUBMISSION_PERIOD_YEAR
  window.FORM230_SUBMISSION_PERIOD_YEAR =
    yearEnv && /^\d{4}$/.test(String(yearEnv)) ? parseInt(yearEnv, 10) : null
}

const Formular230 = (props) => {
  const [envError, setEnvError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  // Initialize Supabase credentials as global variables
  useEffect(() => {
    try {
    // Set the Supabase credentials from environment variables
    if (process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_API_KEY) {
      window.SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
      window.SUPABASE_API_KEY = process.env.REACT_APP_SUPABASE_API_KEY;
      
      // Initialize the Supabase client here in the React component
        if (!window.supabaseClient) {
          if (window.supabase) {
            try {
        window.supabaseClient = window.supabase.createClient(
          window.SUPABASE_URL,
          window.SUPABASE_API_KEY
        );
        console.log('Supabase client initialized successfully');
            } catch (error) {
              console.error('Error initializing Supabase client:', error);
              setEnvError(true);
              setErrorMessage('Failed to initialize database connection. Please refresh the page.');
      }
    } else {
            console.error('Supabase library not loaded. Check if the CDN script is included properly.');
            setEnvError(true);
            setErrorMessage('Required library not loaded. Please refresh the page.');
          }
        }
      } else {
        throw new Error('Required Supabase credentials are not set in environment variables');
      }
      
      // Set other environment variables on window for script access
      if (process.env.REACT_APP_API_URL) {
        window.REACT_APP_API_URL = process.env.REACT_APP_API_URL;
      } else {
        throw new Error('Required API URL is not set in environment variables');
      }
      
      if (process.env.REACT_APP_AUTH_URL) {
        window.REACT_APP_AUTH_URL = process.env.REACT_APP_AUTH_URL;
      } else {
        throw new Error('Required Auth URL is not set in environment variables');
      }
    } catch (err) {
      console.error('Error setting up environment:', err);
      setEnvError(true);
      setErrorMessage(err.message);
    }
  }, []);

  // Fallback UI for environment variable errors
  if (envError) {
    return (
      <div className="env-error-container">
        <h1>Configuration Error</h1>
        <p>The application could not initialize due to missing environment variables.</p>
        <p className="error-details">{errorMessage}</p>
        <p>Please contact the administrator to resolve this issue.</p>
      </div>
    );
  }

  return (
    <div className="formular230-container10">
      <Helmet>
        <title>Formular230 - @Romania</title>
        <meta
          property="og:title"
          content="Formular230 - @Romania"
        />
      </Helmet>
      <img alt="image" src="/external/map.svg" className="formular230-map" />
      <img
        alt="image"
        sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
        src="/external/compressed-7100w-5500w.gif"
        srcSet="/external//compressed-7100w-5500w.gif 1200w, /external/compressed-7100w-tablet.gif 800w, /external/compressed-7100w-mobile.gif 480w"
        className="formular230-gif"
      />
      <div className="formular230-hero">
        <div id="form230-heading" className="formular230-heading">
          <h1 className="formular230-text10">
            <span>
              Completează
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span className="formular230-text12">Formularul 230</span>
            <span> 📃</span>
          </h1>
          <span className="formular230-text14">
            pentru a redirecționa 3.5% din impozitul tău pe venit către @Romania
          </span>
          <h3 className="formular230-text14-sub">
              Vei fi înscris automat în tragerea la sorți pentru 7 nopți la Anna Charisma Chalet după ce trimiți formularul
            </h3>
        </div>
        <form
          id="form230"
          name="Form230"
          noValidate={true}
          className="formular230-form230"
        >
          <button
            id="feedbackMessage"
            type="button"
            className="formular230-button10"
          >
            Feedback:
          </button>
          <div id="section-confirm" className="form230-section">
            <div className="form230-body">
              <div id="employment-confirm-container" className="formular230-terms" onClick={(e) => {
                // Only handle container clicks, not direct checkbox clicks
                if (e.target.tagName !== 'INPUT') {
                  const checkbox = document.getElementById('Employment-Confirm');
                  if (checkbox) {
                    checkbox.checked = !checkbox.checked;
                    
                    // Update button state
                    const button = document.getElementById('confirm-button');
                    if (button) {
                      if (checkbox.checked) {
                        button.style.opacity = '1';
                        button.style.cursor = 'pointer';
                        button.disabled = false;
                        document.getElementById('employment-confirm-container').classList.add('checked');
                      } else {
                        button.style.opacity = '0.5';
                        button.style.cursor = 'not-allowed';
                        button.disabled = true;
                        document.getElementById('employment-confirm-container').classList.remove('checked');
                      }
                    }
                  }
                }
              }}>
                <input
                  type="checkbox"
                  id="Employment-Confirm"
                  required
                  className="formular230-checkbox1"
                  onChange={(e) => {
                    // Handle direct checkbox changes
                    const button = document.getElementById('confirm-button');
                    if (button) {
                      if (e.target.checked) {
                        button.style.opacity = '1';
                        button.style.cursor = 'pointer';
                        button.disabled = false;
                        document.getElementById('employment-confirm-container').classList.add('checked');
                      } else {
                        button.style.opacity = '0.5';
                        button.style.cursor = 'not-allowed';
                        button.disabled = true;
                        document.getElementById('employment-confirm-container').classList.remove('checked');
                      }
                    }
                  }}
                />
                <span>
                  <span>Sunt angajat cu carte de muncă în România și completez acest formular în nume propriu.</span>
                </span>
              </div>
              <button 
                type="button" 
                id="confirm-button" 
                className="button_blue" 
                style={{ opacity: '0.5', cursor: 'not-allowed' }}
                onClick={() => {
                  const checkbox = document.getElementById('Employment-Confirm');
                  if (checkbox && checkbox.checked) {
                    // Show the name section
                    const sections = [
                      'section-confirm',
                      'section-name',
                      'section-cnp',
                      'section-address',
                      'section-location',
                      'section-contact',
                      'section-sign'
                    ];
                    
                    sections.forEach(function(sectionId) {
                      const el = document.getElementById(sectionId);
                      if (el) el.style.display = (sectionId === 'section-name') ? 'flex' : 'none';
                    });
                  } else {
                    // Show error message
                    const feedback = document.getElementById('feedbackMessage');
                    if (feedback) {
                      feedback.innerText = 'Trebuie să confirmi că ești angajat cu carte de muncă în România.';
                      feedback.style.opacity = '1';
                    }
                  }
                }}
              >
                <span>continuă</span>
              </button>
            </div>
          </div>
          <div id="section-name" className="form230-section" style={{ display: 'none' }}>
            <div className="form230-topnav">
              <h1 className="formular230-text15">Cum te numești? 👋</h1>
              <span className="formular230-text16">pasul 1/6</span>
            </div>
            <div className="form230-body">
              <div className="input-container">
                <input
                  type="text"
                  id="Prenume-230"
                  name="Prenume-230"
                  required
                  placeholder=" "
                  className="input-230"
                />
                <label htmlFor="Prenume-230">Prenume</label>
              </div>
              <div className="input-container">
                <input
                  type="text"
                  id="Nume-230"
                  name="Nume-230"
                  required
                  placeholder=" "
                  className="input-230"
                />
                <label htmlFor="Nume-230">Nume de familie</label>
              </div>
            </div>
            <div className="formular230-bot-nav1 form230-botnav">
              <button
                type="button"
                className="formular230-button11 button_gray button_blue"
              >
                <svg width="22" height="22" viewBox="0 0 48 48">
                  <defs>
                    <mask id="ipTBack0">
                      <path
                        d="M44 40.836q-7.34-8.96-13.036-10.168t-10.846-.365V41L4 23.545L20.118 7v10.167q9.523.075 16.192 6.833q6.668 6.758 7.69 16.836Z"
                        fill="#555"
                        stroke="#fff"
                        clipRule="evenodd"
                        fillRule="evenodd"
                        strokeWidth="4"
                        strokeLinejoin="round"
                      ></path>
                    </mask>
                  </defs>
                  <path
                    d="M0 0h48v48H0z"
                    fill="currentColor"
                    mask="url(#ipTBack0)"
                  ></path>
                </svg>
                <span>înapoi</span>
              </button>
              <button type="button" className="button_blue btn-next">
                <span>continuă</span>
              </button>
            </div>
          </div>
          <div id="section-cnp" className="formular230-cnp1 form230-section">
            <div className="form230-topnav">
              <h1 className="formular230-text21">Care este CNP-ul tău?</h1>
              <span className="formular230-text22">pasul 2/6</span>
            </div>
            <div className="input-container">
              <input
                type="text"
                id="CNP-230"
                name="CNP-230"
                pattern="\\d&#123;13&#125;"
                required
                inputMode="numeric"
                placeholder=" "
                autoComplete="off"
                className="input-230"
              />
              <label htmlFor="CNP-230">CNP</label>
            </div>
            <div className="form230-botnav">
              <button
                type="button"
                className="btn-prev button_gray button_blue"
              >
                <span>înapoi</span>
              </button>
              <button
                type="button"
                className="formular230-button14 button_blue btn-next"
              >
                <span>continuă</span>
              </button>
            </div>
          </div>
          <div
            id="section-address"
            className="formular230-adresa form230-section"
          >
            <div className="form230-topnav">
              <h1 className="formular230-text26">Ce adresă ai în buletin?</h1>
              <span className="formular230-text27">pasul 3/6</span>
            </div>
            <div className="address-section">
              <div className="address-selector">
                <label
                  id="bloc-btn"
                  htmlFor="bloc"
                  className="active selector-btn"
                >
                  Bloc 🏢
                </label>
                <label id="casa-btn" htmlFor="casa" className="selector-btn">
                  Casă 🏡
                </label>
              </div>
              <div className="address-fields">
                <div className="common-grid">
                  <div className="input-container">
                    <input
                      type="text"
                      id="Strada-230"
                      name="Strada-230"
                      required
                      placeholder=" "
                      className="input-230"
                    />
                    <label htmlFor="Strada-230">Stradă</label>
                  </div>
                  <div className="input-container">
                    <input
                      type="text"
                      id="NrStr-230"
                      name="NrStr-230"
                      required
                      placeholder=" "
                      className="formular230-textinput14 input-230"
                    />
                    <label htmlFor="NrStr-230">Număr</label>
                  </div>
                </div>
                <div className="block-grid">
                  <div className="input-container">
                    <input
                      type="text"
                      id="Bloc-230"
                      name="Bloc-230"
                      required
                      placeholder=" "
                      className="input-230"
                    />
                    <label htmlFor="Bloc-230">Bloc</label>
                  </div>
                  <div className="input-container">
                    <input
                      type="text"
                      id="Scara-230"
                      name="Scara-230"
                      required
                      placeholder=" "
                      className="input-230"
                    />
                    <label htmlFor="Scara-230">Scară</label>
                  </div>
                  <div className="input-container">
                    <input
                      type="text"
                      id="Etaj-230"
                      name="Etaj-230"
                      required
                      placeholder=" "
                      className="input-230"
                    />
                    <label htmlFor="Etaj-230">Etaj</label>
                  </div>
                  <div className="input-container">
                    <input
                      type="text"
                      id="Ap-230"
                      name="Ap-230"
                      required
                      placeholder=" "
                      className="input-230"
                    />
                    <label htmlFor="Ap-230">Apartament</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="form230-botnav">
              <button
                type="button"
                className="btn-prev button_gray button_blue"
              >
                <span>înapoi</span>
              </button>
              <button
                type="button"
                className="formular230-button16 button_blue btn-next"
              >
                <span>continuă</span>
              </button>
            </div>
          </div>
          <div
            id="section-location"
            className="formular230-localitate1 form230-section"
          >
            <div className="form230-topnav">
              <h1 className="formular230-text36">Ce adresă ai în buletin?</h1>
              <span className="formular230-text37">pasul 4/6</span>
            </div>
            <div className="form230-body">
              <div className="floating-select input-container">
                <label
                  htmlFor="countySelect"
                  className="formular230-text38 floating-label"
                >
                  Județ
                </label>
                <select
                  id="countySelect"
                  name="Judet-230"
                  required
                  className="input-230 select2"
                >
                  <option></option>
                </select>
              </div>
              <div className="floating-select input-container">
                <label
                  htmlFor="citySelect"
                  className="formular230-text39 floating-label"
                >
                  Oraș
                </label>
                <select
                  id="citySelect"
                  name="Localitate-230"
                  required
                  className="input-230 select2"
                >
                  <option></option>
                </select>
              </div>
            </div>
            <div className="form230-botnav">
              <button
                type="button"
                className="btn-prev button_gray button_blue"
              >
                <span>înapoi</span>
              </button>
              <button
                type="button"
                className="formular230-button18 button_blue btn-next"
              >
                <span>continuă</span>
              </button>
            </div>
          </div>
          <div
            id="section-contact"
            className="formular230-contact1 form230-section"
          >
            <div className="form230-topnav">
              <h1 className="formular230-text42">
                Care sunt datele tale de contact?
              </h1>
              <span className="formular230-text43">pasul 5/6</span>
            </div>
            <div className="form230-body">
              <div className="phone-incentive-container">
                <div className="phone-incentive-banner">
                  <img
                    src={reward1_1Image}
                    alt="Vacanță de vis în Transilvania"
                    className="phone-banner-image"
                  />
                </div>
                <div className="phone-banner-content">
                  <h3 className="phone-banner-title">
                    Adaugă numărul tău de telefon pentru a afla dacă ai câștigat 7 nopți la Anna Charisma Chalet!
                  </h3>
                  <p className="phone-banner-text">
                    Dupa completarea formularului, vei fi înregistrat automat la tombola prin care poți câștiga această vacanță de vis!
                    Avem nevoie de numărul tău pentru a te contacta dacă ai câștigat!
                  </p>
                </div>
              </div>
              <div className="input-container">
                <input
                  type="email"
                  id="Email-230"
                  name="Email-230"
                  required
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  placeholder=" "
                  className="input-230"
                />
                <label htmlFor="Email-230">Email</label>
              </div>
              <div className="input-container">
                <input
                  type="tel"
                  id="Tel-230"
                  name="Tel-230"
                  placeholder=" "
                  className="input-230"
                  pattern="^\+?[0-9]{1,15}$"
                  maxLength="15"
                  onKeyPress={(e) => {
                    // Allow only numbers and + character
                    const char = e.key;
                    if (char === '+' && e.target.value.length === 0) {
                      return true; // Allow + only at the start
                    }
                    if (!/^[0-9]$/.test(char)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    // Remove any non-numeric characters except + at start
                    const value = e.target.value;
                    if (value.length > 0) {
                      const cleanValue = value.startsWith('+') 
                        ? '+' + value.slice(1).replace(/[^0-9]/g, '')
                        : value.replace(/[^0-9]/g, '');
                      e.target.value = cleanValue;
                    }
                  }}
                />
                <label htmlFor="Tel-230">Număr de telefon</label>
              </div>
            </div>
            <div className="form230-botnav">
              <button
                type="button"
                className="btn-prev button_gray button_blue"
              >
                <span>înapoi</span>
              </button>
              <button
                type="button"
                className="formular230-button20 button_blue btn-next"
              >
                <span>continuă</span>
              </button>
            </div>
          </div>
          <div id="section-sign" className="formular230-sign1 form230-section">
            <div className="form230-topnav">
              <h1 className="formular230-text48">
                Semnează în chenar și trimite formularul
              </h1>
              <span className="formular230-text49">pasul 6/6</span>
            </div>
            <div className="formular230-body5 form230-body">
              <div className="formular230-sign2">
                <div id="sign-status" className="formular230-container11">
                  <div
                    id="signature-pad-230"
                    name="Signature-230"
                    className="formular230-signaturepad"
                  ></div>
                </div>
                <span
                  id="signature-pad-230-erase"
                  className="formular230-text50"
                  translate="no"
                >
                  semnătură nouă ✒️
                </span>
              </div>
              <div className="formular230-buttons">
                <span className="formular230-text51">Vezi modelul 📃</span>
                <span className="formular230-text52">Previzualizează 👁️‍🗨️</span>
              </div>
              <div className="formular230-checkboxes">
                <div id="terms-btn" className="formular230-terms">
                  <input
                    type="checkbox"
                    id="Terms-230"
                    required
                    className="formular230-checkbox1"
                  />
                  <span>
                    <span>Sunt de acord cu</span>
                    <span className="formular230-text55">
                      {' '}
                      <Link to={`/termeni${window.location.search}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', borderBottom: '2px solid transparent', transition: 'border-color 0.2s ease' }} onMouseOver={(e) => e.target.style.borderColor = '#3066FF'} onMouseOut={(e) => e.target.style.borderColor = 'transparent'}>Termenii</Link>
                      {' '}și{' '}
                      <Link to={`/confidentialitate${window.location.search}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', borderBottom: '2px solid transparent', transition: 'border-color 0.2s ease' }} onMouseOver={(e) => e.target.style.borderColor = '#3066FF'} onMouseOut={(e) => e.target.style.borderColor = 'transparent'}>Politica de Confidențialitate</Link>
                    </span>
                  </span>
                </div>
                <div id="period-btn" className="formular230-terms">
                  <input
                    type="checkbox"
                    id="Period-230"
                    required
                    className="formular230-checkbox1"
                  />
                  <span>
                    <span>Sunt de acord cu perioada redirecționării de 2 ani</span>
                  </span>
                </div>
                <div id="notif-btn" className="formular230-contact2">
                  <input
                    type="checkbox"
                    id="Notif-230"
                    className="formular230-checkbox2"
                  />
                  <span>
                    <span>Vreau să fiu înștiințat dacă am câștigat vacanța!</span>
                  </span>
                </div>
              </div>
            </div>
            <div className="form230-botnav">
              <button
                type="button"
                className="btn-prev button_gray button_blue"
              >
                <span>înapoi</span>
              </button>
              <button type="submit" className="button_blue btn-submit">
                <span>trimite formularul 📃</span>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div>
        <div className="formular230-container13">
          <React.Fragment>
            <React.Fragment>
              <Script>{`
(function(){
  const blocBtn = document.getElementById("bloc-btn");
  const casaBtn = document.getElementById("casa-btn");
  const blockGrid = document.querySelector(".block-grid");
  
  // List of input element IDs inside blockGrid.
  const inputIds = ["Bloc-230", "Scara-230", "Etaj-230", "Ap-230"];

  // Function to update the "required" property for each input element.
  function setInputsRequired(isRequired) {
    inputIds.forEach(function(id) {
      const inputElement = document.getElementById(id);
      if(inputElement) {
        inputElement.required = isRequired;
      }
    });
  }

  blocBtn.addEventListener("click", function () {
    blocBtn.classList.add("active");
    casaBtn.classList.remove("active");
    blockGrid.style.display = "grid";
    // Set inputs back to required when the grid is shown.
    setInputsRequired(true);
  });

  casaBtn.addEventListener("click", function () {
    casaBtn.classList.add("active");
    blocBtn.classList.remove("active");
    blockGrid.style.display = "none";
    // Remove required attribute when the grid is hidden.
    setInputsRequired(false);
  });
})();
`}</Script>
            </React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div>
        <div className="formular230-container15">
          <React.Fragment>
<Script>{`
\$(document).ready(function() {
  // Initialize Select2 on the selectors with a placeholder and percentage width.
  \$('#countySelect').select2({
    placeholder: "Alege județ",
    width: "100%"
  });
  \$('#citySelect').select2({
    placeholder: "Localitate",
    width: "100%"
  });
  
  // Disable city select initially
  \$('#citySelect').prop('disabled', true);
  
  // Get API URL from window 
  if (!window.REACT_APP_API_URL) {
    throw new Error('API URL environment variable is not set');
  }
  // Log the API URL for debugging (will be removed in production)
  console.log('API URL being used:', window.REACT_APP_API_URL);
  
  // Ensure the API URL is properly formatted with the /api path
  var BASE_API_URL = window.REACT_APP_API_URL;
  
  // Check if the API URL already includes /api, if not, append it
  if (BASE_API_URL && !BASE_API_URL.endsWith('/api')) {
    if (BASE_API_URL.endsWith('/')) {
      BASE_API_URL = BASE_API_URL + 'api';
    } else {
      BASE_API_URL = BASE_API_URL + '/api';
    }
  }
  
  console.log('Adjusted API URL:', BASE_API_URL);
  
  // Add CORS mode to fetch requests
  var fetchOptions = {
    mode: 'cors',
    headers: {
      'Origin': window.location.origin
    }
  };
  
  // Populate counties from the API.
  console.log('Fetching counties from:', BASE_API_URL + "/judete");
  fetch(BASE_API_URL + "/judete", fetchOptions)
    .then(response => {
      console.log('Counties API response status:', response.status);
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.status);
      }
      return response.json();
    })
    .then(counties => {
      var \$countySelect = \$('#countySelect');
      if (counties && Array.isArray(counties)) {
      counties.forEach(function(county) {
        var newOption = new Option(county.denumire, county.cod_jud, false, false);
        \$countySelect.append(newOption);
      });
      \$countySelect.trigger('change');
      }
    })
    .catch(error => {
      // Replace with quiet error handling in production
      if (window.REACT_APP_ENV !== 'production') {
        console.error("Error loading counties:", error);
      }
      // Add fallback UI for error state
      var \$countySelect = \$('#countySelect');
      \$countySelect.parent().append('<div class="api-error">Datele nu pot fi încărcate. Reîncercați mai târziu.</div>');
    });
  
  // When a county is selected, fetch the corresponding cities.
  \$('#countySelect').on('change', function() {
    var selectedCounty = \$(this).val();
    var \$citySelect = \$('#citySelect');
    
    // Reset the city select.
    \$citySelect.empty().append(new Option("Localitate", "", false, false));
    // Keep disabled while loading
    \$citySelect.prop('disabled', true).trigger('change');
    
    if (selectedCounty) {
      \$citySelect.prop('disabled', false);
      fetch(BASE_API_URL + "/orase?cod_jud=" + selectedCounty, fetchOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok: ' + response.status);
          }
          return response.json();
        })
        .then(cities => {
          if (cities && Array.isArray(cities)) {
          cities.forEach(({ value, label }) => {
            // Use the unique cod_loc as the value and the computed label
            var newOption = new Option(label, value, false, false);
            \$citySelect.append(newOption);
          });
          \$citySelect.trigger('change');
          // Enable city select after loading
          \$citySelect.prop('disabled', false).trigger('change');
          }
        })
        .catch(err => {
          // Replace with quiet error handling in production
          if (window.REACT_APP_ENV !== 'production') {
            console.error("Error loading cities:", err);
          }
          // Add fallback UI for error state
          \$citySelect.parent().append('<div class="api-error">Datele nu pot fi încărcate. Reîncercați mai târziu.</div>');
        });
    } else {
      \$citySelect.prop('disabled', true).trigger('change');
    }
  });
  
  // When a Select2 dropdown opens, focus and pre-select the search input.
  \$(document).on('select2:open', function() {
    \$('.select2-search__field').focus().select();
  });
});
`}
</Script>
          </React.Fragment>
        </div>
      </div>
      <div>
        <div className="formular230-container17">
          <React.Fragment>
            <React.Fragment>
              <Script>{`
  (function(){
    // Get the container for the signature pad
    const padContainer = document.getElementById('signature-pad-230');
    if (padContainer) {
      let signatureCanvas;
      // If the container is not a canvas, create one and append it
      if (padContainer.tagName.toLowerCase() !== 'canvas') {
        signatureCanvas = document.createElement('canvas');
        signatureCanvas.id = 'signature-pad-230-canvas';
        // Set desired dimensions
        signatureCanvas.width = 450;
        signatureCanvas.height = 180;
        padContainer.appendChild(signatureCanvas);
      } else {
        signatureCanvas = padContainer;
      }
      
      // Initialize the SignaturePad instance
      const signaturePad230 = new SignaturePad(signatureCanvas);
      // Expose signaturePad230 to the global scope:
      window.signaturePad230 = signaturePad230;
      console.log("SignaturePad-230 initialized:", signaturePad230);
      
      // Get the erase button by its ID and add a click event to clear the signature pad
      const eraseButton = document.getElementById('signature-pad-230-erase');
      if (eraseButton) {
        eraseButton.addEventListener('click', () => {
          signaturePad230.clear();
          console.log("SignaturePad-230 cleared.");
        });
      } else {
        console.error("Erase button with ID 'signature-pad-230-erase' not found.");
      }
    } else {
      console.error("Signature pad container with ID 'signature-pad-230' not found.");
    }
  })();
`}</Script>
            </React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div>
        <div className="formular230-container19">
          <React.Fragment>
            <React.Fragment>
              <Script>{`
// ----------------- Global Variables -----------------
var sections = [
  'section-confirm',
  'section-name',
  'section-cnp',
  'section-address',
  'section-location',
  'section-contact',
  'section-sign'
];

// Duplicate CNP/email/affiliate checks only block another row in the same submission period year
// (local midnight Jan 1 → next Jan 1), using created_at on form230_submissions.
function getForm230SubmissionPeriodYear() {
  if (typeof window.FORM230_SUBMISSION_PERIOD_YEAR === 'number' &&
      !Number.isNaN(window.FORM230_SUBMISSION_PERIOD_YEAR)) {
    return window.FORM230_SUBMISSION_PERIOD_YEAR;
  }
  return new Date().getFullYear();
}

function getForm230PeriodTimeBounds(year) {
  var start = new Date(year, 0, 1, 0, 0, 0, 0);
  var end = new Date(year + 1, 0, 1, 0, 0, 0, 0);
  return { startIso: start.toISOString(), endIso: end.toISOString() };
}

// ----------------- Navigation Logic -----------------
for (var i = 1; i < sections.length; i++) {
  var sec = document.getElementById(sections[i]);
  if (sec) sec.style.display = 'none';
}
var firstSection = document.getElementById(sections[0]);
if (firstSection) firstSection.style.display = 'flex';

// Note: We're keeping this function for backwards compatibility,
// but the direct navigation from confirmation to name section
// is now handled in the React component's onClick handler
function showSection(targetId) {
  sections.forEach(function(sectionId) {
    var el = document.getElementById(sectionId);
    if (el) el.style.display = (sectionId === targetId) ? 'flex' : 'none';
  });
}

// ----------------- Employment Confirmation Checkbox -----------------
document.addEventListener('DOMContentLoaded', function() {
  // The checkbox and button functionality is now handled directly in the React component
  // This event listener is kept for compatibility with the rest of the form navigation
  
  // We still need to prevent container click from triggering when clicking directly on the checkbox
  const confirmCheckbox = document.getElementById('Employment-Confirm');
  const confirmContainer = document.getElementById('employment-confirm-container');
  
  if (confirmCheckbox && confirmContainer) {
    // Prevent double-toggle when clicking directly on the checkbox
    confirmCheckbox.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }
});

// ----------------- Validation Functions -----------------
function validateSection(sectionId) {
  var valid = true;
  var section = document.getElementById(sectionId);
  if (!section) return true;
  var requiredFields = section.querySelectorAll('[required]');
  requiredFields.forEach(function(field) {
    if (field.tagName.toLowerCase() === 'select') {
      var container = field.nextElementSibling;
      if (!field.value.trim()) {
        valid = false;
        if (container && container.classList.contains('select2-container')) {
          var single = container.querySelector('.select2-selection--single');
          if (single) single.style.borderColor = '#3066FF';
        }
      } else if (container && container.classList.contains('select2-container')) {
        var singleOk = container.querySelector('.select2-selection--single');
        if (singleOk) singleOk.style.borderColor = '#191818';
      }
    } else if (field.type === 'checkbox' || field.type === 'radio') {
      if (!field.checked) { 
        valid = false; 
        // Find the parent container and highlight it
        const container = field.closest('.formular230-terms, .formular230-contact2');
        if (container) {
          container.classList.add('highlight-required');
        }
      } else { 
        // Remove highlight when checked
        const container = field.closest('.formular230-terms, .formular230-contact2');
        if (container) {
          container.classList.remove('highlight-required');
        }
      }
    } else {
      if (!field.value.trim()) { valid = false; field.style.borderColor = '#3066FF'; }
      else { field.style.borderColor = '#191818'; }
    }
  });
  if (sectionId === 'section-sign') {
    if (window.signaturePad230 && window.signaturePad230.isEmpty()) {
      valid = false;
      var signStatus = document.getElementById('sign-status');
      if (signStatus) signStatus.style.borderColor = '#3066FF';
    }
  }
  var feedback = document.getElementById('feedbackMessage');
  if (feedback) {
    if (!valid) { feedback.innerText = 'Completează câmpurile necesare.'; feedback.style.opacity = '1'; }
    else { feedback.innerText = ''; feedback.style.opacity = '0'; }
  }
  return valid;
}

// ----------------- Realtime Validation -----------------
function attachRealtimeValidation(sectionId) {
  var section = document.getElementById(sectionId);
  if (!section) return;
  var fields = section.querySelectorAll('[required]');
  fields.forEach(function(field) {
    if (field.tagName.toLowerCase() === 'select') {
      \$(field).on('change', function() {
        if (\$(field).val() && \$(field).val().toString().trim()) {
          var container = \$(field).data('select2').\$container;
          if (container) container.find('.select2-selection--single').css('border-color', '#191818');
          \$('#feedbackMessage').text('').css('opacity', '0');
        }
      });
    } else if (field.type === 'checkbox' || field.type === 'radio') {
      field.addEventListener('change', function() {
        const container = field.closest('.formular230-terms, .formular230-contact2');
        if (field.checked) { 
          if (container) container.classList.remove('highlight-required');
          var fb = document.getElementById('feedbackMessage'); 
          if (fb) { fb.innerText = ''; fb.style.opacity = '0'; } 
        }
      });
    } else {
      field.addEventListener('input', function() {
        if (field.value.trim()) {
          field.style.borderColor = '#191818';
          var fb = document.getElementById('feedbackMessage'); if (fb) { fb.innerText = ''; fb.style.opacity = '0'; }
        }
      });
    }
  });
}
sections.forEach(attachRealtimeValidation);

// ----------------- CNP and Email Validation -----------------
// CNP Functions
function normalizeCnpInput(raw) {
  return raw.replace(/\\D/g, '');
}

function formatAndControlCheck(cnp) {
  if (cnp.length !== 13) {
    return { ok: false, msg: 'CNP-ul trebuie să conțină exact 13 cifre.' };
  }
  const S   = +cnp[0];
  const YY  = +cnp.substr(1, 2);
  const MM  = +cnp.substr(3, 2);
  const DD  = +cnp.substr(5, 2);
  const JJ  = +cnp.substr(7, 2);
  const NNN = +cnp.substr(9, 3);
  const C   = +cnp[12];

  if (S < 1 || S > 8) {
    return { ok: false, msg: 'CNP-ul introdus nu este corect.' };
  }
  let century;
  if (S === 1 || S === 2)        century = 1900;
  else if (S === 3 || S === 4)   century = 1800;
  else if (S === 5 || S === 6)   century = 2000;
  else /*7 or 8*/                century = 1900;

  const year = century + YY;
  const date = new Date(year, MM - 1, DD);
  if (date.getFullYear() !== year || date.getMonth() + 1 !== MM || date.getDate() !== DD) {
    return { ok: false, msg: 'CNP-ul introdus nu este corect.' };
  }
  if (JJ < 1 || JJ > 52) {
    return { ok: false, msg: 'CNP-ul introdus nu este corect.' };
  }
  if (NNN < 1 || NNN > 999) {
    return { ok: false, msg: 'CNP-ul introdus nu este corect.' };
  }
  const weights = [2,7,9,1,4,6,3,5,8,2,7,9];
  let sum = 0;
  for (let i = 0; i < 12; i++) sum += +cnp[i] * weights[i];
  const control = sum % 11 === 10 ? 1 : sum % 11;
  if (control !== C) {
    return { ok: false, msg: 'CNP-ul introdus nu este corect.' };
  }
  return { ok: true };
}

async function validateAndCheckCNP(raw) {
  const normalized = normalizeCnpInput(raw);
  if (normalized.length !== raw.trim().length) {
    return { ok: false, msg: 'Folosește doar cifre (0–9) în CNP.' };
  }
  const fmt = formatAndControlCheck(normalized);
  if (!fmt.ok) return fmt;

  // uniqueness
  try {
    if (!window.supabaseClient) {
      console.warn('Supabase client not initialized. Skipping CNP database check.');
      return { ok: true, normalized };
    }
    
    var periodYear = getForm230SubmissionPeriodYear();
    var bounds = getForm230PeriodTimeBounds(periodYear);
    const { data, error } = await window.supabaseClient
      .from('form230_submissions')
      .select('id')
      .eq('cnp', normalized)
      .gte('created_at', bounds.startIso)
      .lt('created_at', bounds.endIso)
      .maybeSingle();
    if (error) console.error('Supabase error:', error);
    else if (data) return { ok: false, msg: 'Acest CNP a fost deja înregistrat pentru această perioadă. Dacă ai completat formularul într-un an anterior, poți trimite din nou acum.' };
  } catch (err) {
    console.error('Supabase exception:', err);
  }
  return { ok: true, normalized };
}

// Email validation function
function validateEmailFormat(email) {
  if (!email) return false;
  
  // Basic format checks
  if (email.includes('..')) return false; // No consecutive dots
  if (email.startsWith('.') || email.endsWith('.')) return false; // No dots at start/end
  if (email.split('@').length !== 2) return false; // Exactly one @ symbol
  
  const [localPart, domain] = email.split('@');
  
  // Length checks
  if (localPart.length > 64 || domain.length > 255) return false; // RFC 5321 length limits
  if (localPart.length === 0 || domain.length === 0) return false; // No empty parts
  
  // Domain format checks
  const domainParts = domain.split('.');
  if (domainParts.length < 2) return false; // Must have at least one dot in domain
  if (domainParts.some(part => part.length === 0)) return false; // No empty parts between dots
  
  // TLD checks
  const tld = domainParts[domainParts.length - 1];
  if (tld.length < 2) return false; // TLD must be at least 2 characters
  if (!/^[a-z]{2,}$/i.test(tld)) return false; // TLD must be only letters
  
  // Domain part checks
  for (let i = 0; i < domainParts.length - 1; i++) {
    const part = domainParts[i];
    if (part.length > 63) return false; // Each domain part must be <= 63 chars
    if (!/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(part)) return false; // Valid domain part format
  }
  
  // Local part checks
  if (!/^[a-z0-9](?:[a-z0-9._%+-]*[a-z0-9])?$/i.test(localPart)) return false; // Valid local part format
  
  // Final basic regex check
  return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email);
}

// Email check against database
async function checkEmailInDatabase(email) {
  try {
    if (!window.supabaseClient) {
      console.warn('Supabase client not initialized. Skipping email database check.');
      return { exists: false, error: true, message: 'Database connection not available. Please refresh the page.' };
    }
    
    var periodYear2 = getForm230SubmissionPeriodYear();
    var bounds2 = getForm230PeriodTimeBounds(periodYear2);
    const { data, error } = await window.supabaseClient
      .from('form230_submissions')
      .select('id, email')
      .eq('email', email.trim())
      .gte('created_at', bounds2.startIso)
      .lt('created_at', bounds2.endIso)
      .maybeSingle();
      
    if (error) {
      console.error('Supabase error:', error);
      return { exists: false, error: true, message: 'Error checking email. Please try again.' };
    }
    
    return { exists: !!data, error: false };
  } catch (err) {
    console.error('Email check exception:', err);
    return { exists: false, error: true, message: 'Error checking email. Please try again.' };
  }
}

// Debounce function to delay validation
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Email validation function that will be debounced
async function validateEmail(email) {
  if (!window.emailField || !window.feedback) return;
  
    window.emailField.style.borderColor = '#191818';
      window.feedback.innerText = '';
      window.feedback.style.opacity = '0';
    
    if (!email) return; // Empty validation handled by required attribute
    
    if (!validateEmailFormat(email)) {
      window.emailField.style.borderColor = '#3066FF';
        window.feedback.innerText = 'Adresa de email nu este validă.';
        window.feedback.style.opacity = '1';
      return;
    }
    
    // Check database for existing email
    const emailCheck = await checkEmailInDatabase(email);
  if (emailCheck.error) {
    window.emailField.style.borderColor = '#3066FF';
    window.feedback.innerText = emailCheck.message;
    window.feedback.style.opacity = '1';
    return;
  }
  
    if (emailCheck.exists) {
      window.emailField.style.borderColor = '#3066FF';
        window.feedback.innerText = 'Această adresă de email este deja înregistrată pentru această perioadă. Folosește altă adresă, conectează-te la cont, sau revino dacă ai mai completat formularul într-un an anterior.';
        window.feedback.style.opacity = '1';
      
      // Find the next button in the contact section
      const contactSection = document.getElementById('section-contact');
      if (contactSection) {
        const nextButton = contactSection.querySelector('.btn-next');
        if (nextButton) {
          // Change button appearance and behavior
          nextButton.innerText = 'Conectează-te acum';
          nextButton.classList.add('login-redirect');
          nextButton.dataset.email = email;
        }
      }
    } else {
    // Reset button if email is valid and not in database
      const contactSection = document.getElementById('section-contact');
      if (contactSection) {
        const nextButton = contactSection.querySelector('.btn-next');
        if (nextButton && nextButton.classList.contains('login-redirect')) {
          nextButton.innerText = 'continuă';
          nextButton.classList.remove('login-redirect');
          delete nextButton.dataset.email;
        }
      }
  }
}

// Define global variables for fields and feedback
if (!window.cnpField) {
  window.cnpField = document.getElementById('CNP-230');
  window.emailField = document.getElementById('Email-230');
  window.feedback = document.getElementById('feedbackMessage');
}

// CNP blur validation
if (window.cnpField) {
  window.cnpField.addEventListener('blur', async () => {
    const raw = window.cnpField.value;
    window.cnpField.style.borderColor = '#191818';
    if (window.feedback) {
      window.feedback.innerText = '';
      window.feedback.style.opacity = '0';
    }
    const res = await validateAndCheckCNP(raw);
    if (!res.ok) {
      window.cnpField.style.borderColor = '#3066FF';
      if (window.feedback) {
        window.feedback.innerText = res.msg;
        window.feedback.style.opacity = '1';
      }
    } else if (res.normalized) {
      window.cnpField.value = res.normalized;
    }
  });
}

// Email field input validation with debounce
if (window.emailField) {
  const debouncedValidate = debounce((email) => validateEmail(email), 500); // 500ms delay
  
  window.emailField.addEventListener('input', () => {
    const email = window.emailField.value.trim();
    debouncedValidate(email);
  });
}

// ----------------- Button Listeners -----------------
var nextButtons = document.querySelectorAll('.btn-next');
nextButtons.forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    // immediately block original navigation
    e.preventDefault();
    e.stopImmediatePropagation();

    (async () => {
      const section = e.target.closest('.form230-section');

      // Check if this is a login redirect button
      if (this.classList.contains('login-redirect')) {
        // Redirect to login page with email as parameter
        if (!window.REACT_APP_AUTH_URL) {
          console.error('Authentication URL environment variable is not set');
          return;
        }
        const loginUrl = window.REACT_APP_AUTH_URL + '?email=' + encodeURIComponent(this.dataset.email || '');
        window.location.href = loginUrl;
        return;
      }

      // CNP section: full CNP check
      if (section && section.id === 'section-cnp' && window.cnpField) {
        window.cnpField.style.borderColor = '#191818';
        if (window.feedback) {
          window.feedback.innerText = '';
          window.feedback.style.opacity = '0';
        }
        const res = await validateAndCheckCNP(window.cnpField.value);
        if (!res.ok) {
          window.cnpField.style.borderColor = '#3066FF';
          if (window.feedback) {
            window.feedback.innerText = res.msg;
            window.feedback.style.opacity = '1';
          }
          return;
        }
      }

      // Email section: validate email format and check for duplicates
      if (section && section.id === 'section-contact' && window.emailField) {
        const email = window.emailField.value.trim();
        window.emailField.style.borderColor = '#191818';
        if (window.feedback) {
          window.feedback.innerText = '';
          window.feedback.style.opacity = '0';
        }

        if (!validateEmailFormat(email)) {
          window.emailField.style.borderColor = '#3066FF';
          if (window.feedback) {
            window.feedback.innerText = 'Adresa de email nu este validă.';
            window.feedback.style.opacity = '1';
          }
          return;
        }

        // Check database for existing email
        const emailCheck = await checkEmailInDatabase(email);
        if (emailCheck.exists) {
          window.emailField.style.borderColor = '#3066FF';
          if (window.feedback) {
            window.feedback.innerText = 'Această adresă de email este deja înregistrată pentru această perioadă. Folosește altă adresă, conectează-te la cont, sau revino dacă ai mai completat formularul într-un an anterior.';
            window.feedback.style.opacity = '1';
          }
           
          // Change button appearance and behavior
          this.innerText = 'Conectează-te acum';
          this.classList.add('login-redirect');
          this.dataset.email = email;
          return;
        }
      }

      // all sections: required-field validation
      if (section && !validateSection(section.id)) {
        return;
      }

      // if everything passes, go to next
      if (section) {
        const idx = sections.indexOf(section.id);
        if (idx >= 0 && idx < sections.length - 1) {
          showSection(sections[idx + 1]);
        }
      }
    })();
  }, true); // capture-phase
});

// ----------------- Reset Function -----------------
function resetFormElements() {
  var form = document.getElementById('form230'); if (form) form.reset();
  if (window.jQuery) \$('.select2').val(null).trigger('change');
  if (window.signaturePad230 && typeof window.signaturePad230.clear === 'function') window.signaturePad230.clear();
  if (window.feedback) { window.feedback.innerText = ''; window.feedback.style.opacity = '0'; }
}

// ----------------- Supabase Form Submission Logic -----------------
// We now rely on the React component to initialize the Supabase client
// No credential fallbacks in the script
(async function checkAffiliateSubmission() {
  // Wait for supabaseClient to be initialized by React component
  if (!window.supabaseClient) {
    console.warn('Supabase client not yet initialized. Skipping affiliate check.');
    return;
  }
  
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref') || '';
  if (!ref.trim()) return;
  const { data: linkData, error: linkError } = await window.supabaseClient
    .from('affiliate_links').select('id, is_custom').eq('code', ref.trim()).maybeSingle();
  if (linkError || !linkData) return;
  if (!linkData.is_custom) {
    var affYear = getForm230SubmissionPeriodYear();
    var affBounds = getForm230PeriodTimeBounds(affYear);
    const { data: subs } = await window.supabaseClient
      .from('form230_submissions')
      .select('id')
      .eq('affiliate_link_id', linkData.id)
      .gte('created_at', affBounds.startIso)
      .lt('created_at', affBounds.endIso);
    if (subs && subs.length) {
      if (window.feedback) { window.feedback.innerText = 'Formularul a fost deja completat prin acest link pentru această perioadă.'; window.feedback.style.opacity = '1'; }
      nextButtons.forEach(btn => { btn.disabled = true; btn.style.cursor = 'not-allowed'; });
      sections.forEach((id,i) => { var s = document.getElementById(id); if (s) s.style.display = i===0?'flex':'none'; });
    }
  }
})();

function dataURLtoFile(dataurl,filename) {
  var arr = dataurl.split(','); var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]); var n=bstr.length; var u8arr=new Uint8Array(n);
  while(n--) u8arr[n]=bstr.charCodeAt(n);
  return new File([u8arr],filename,{type:mime});
}

document.getElementById('form230').addEventListener('submit', async function(e) {
  e.preventDefault();
  var submissionSuccess = false;
  var params = new URLSearchParams(window.location.search);
  var ref = params.get('ref') || '';
  if (window.feedback) { window.feedback.innerText = ''; window.feedback.style.opacity = '0'; }
  var submitBtn = document.querySelector('.btn-submit');
  if (submitBtn) { submitBtn.disabled = true; submitBtn.innerText = 'Se trimite...'; }

  // Check if Supabase client is initialized
  if (!window.supabaseClient) {
    if (window.feedback) { 
      window.feedback.innerText = 'Eroare: Conexiunea la baza de date nu a fost inițializată. Reîncărcați pagina și încercați din nou.'; 
      window.feedback.style.opacity = '1'; 
    }
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.innerText = 'trimite formularul 📃';
    }
    return;
  }

  var county = document.getElementById('countySelect');
  var countyText = county.options[county.selectedIndex].text;
  // Get the selected city name instead of numeric value
  var citySelectElem = document.getElementById('citySelect');
  var cityText = '';
  if (citySelectElem && citySelectElem.options && citySelectElem.selectedIndex >= 0) {
    cityText = citySelectElem.options[citySelectElem.selectedIndex].text.trim();
  }
  try {
    var affiliateUUID = null;
    if (ref.trim()) {
      var resLink = await window.supabaseClient.from('affiliate_links').select('id').eq('code', ref.trim()).maybeSingle();
      if (resLink.error || !resLink.data) throw new Error('Affiliate link lookup failed');
      affiliateUUID = resLink.data.id;
    }
    var data = {
      family_name: document.getElementById('Nume-230').value.trim(),
      first_name: document.getElementById('Prenume-230').value.trim(),
      cnp: document.getElementById('CNP-230').value.trim(),
      adresa_str_nume: document.getElementById('Strada-230').value.trim(),
      adresa_str_nr: document.getElementById('NrStr-230').value.trim(),
      adresa_bloc: document.getElementById('Bloc-230').value.trim(),
      adresa_scara: document.getElementById('Scara-230').value.trim(),
      adresa_etaj: document.getElementById('Etaj-230').value.trim(),
      adresa_ap: document.getElementById('Ap-230').value.trim(),
      adresa_judet: countyText.trim(),
      adresa_local: cityText,
      email: document.getElementById('Email-230').value.trim(),
      nr_tel: document.getElementById('Tel-230').value.trim(),
      sign_url: '',
      terms: document.getElementById('Terms-230').checked,
      perioada_2_ani: document.getElementById('Period-230').checked,
      notifications: document.getElementById('Notif-230').checked,
      affiliate_link_id: affiliateUUID
    };
    if (!validateSection('section-sign')) return;
    if (!window.signaturePad230) throw new Error('SignaturePad instance missing');
    var dataUrl = window.signaturePad230.toDataURL();
    var fname = 'signature_' + Date.now() + '.png';
    var sigFile = dataURLtoFile(dataUrl, fname);
    var up = await window.supabaseClient.storage.from('signatures').upload('form230/' + fname, sigFile);
    if (up.error) throw new Error('Signature upload failed');
    var pubUrl = window.supabaseClient.storage.from('signatures').getPublicUrl(up.data.path).data.publicUrl;
    data.sign_url = pubUrl;
    var ins = await window.supabaseClient.from('form230_submissions').insert([data]);
    if (ins.error) {
      if (window.feedback) { window.feedback.innerText = 'Eroare la trimitere. Încearcă mai târziu.'; window.feedback.style.opacity = '1'; }
      submissionSuccess = false;
    } else {
      submissionSuccess = true;
      if (submitBtn) submitBtn.innerText = 'Trimis 🎉';
      // Get the first name from the form to include in the redirect
      const firstName = document.getElementById('Prenume-230').value.trim();
      window.location.href = '/multumim?nume=' + encodeURIComponent(firstName);
    }
  } catch (err) {
    console.error(err);
    if (window.feedback) { window.feedback.innerText = 'Eroare neașteptată. Încearcă mai târziu.'; window.feedback.style.opacity = '1'; }
    submissionSuccess = false;
  } finally {
    if (!submissionSuccess && submitBtn) {
      submitBtn.disabled = false;
      submitBtn.innerText = 'trimite formularul 📃';
    }
  }
});

// Previous button functionality
var prevButtons = document.querySelectorAll('.btn-prev');
prevButtons.forEach(function(btn) {
  btn.addEventListener('click', function(e) {
    var current = e.target.closest('.form230-section');
    if (!current) return;
    var idx = sections.indexOf(current.id);
    if (idx > 0) showSection(sections[idx - 1]);
  });
});
`}</Script>
            </React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div>
        <div className="formular230-container21">
          <React.Fragment>
            <Script>{`
              (function(){
document.getElementById('terms-btn').addEventListener('click', function(e) {
  // Prevent toggling again when the checkbox itself is clicked
  if (e.target.tagName !== 'INPUT') {
    const termsCheckbox = document.getElementById('Terms-230');
    termsCheckbox.checked = !termsCheckbox.checked;
  }
});

document.getElementById('period-btn').addEventListener('click', function(e) {
  if (e.target.tagName !== 'INPUT') {
    const periodCheckbox = document.getElementById('Period-230');
    periodCheckbox.checked = !periodCheckbox.checked;
  }
});

document.getElementById('notif-btn').addEventListener('click', function(e) {
  if (e.target.tagName !== 'INPUT') {
    const notifCheckbox = document.getElementById('Notif-230');
    notifCheckbox.checked = !notifCheckbox.checked;
  }
});
})()
              `}</Script>
          </React.Fragment>
        </div>
      </div>
      <div>
        <div className="formular230-container23">
          <React.Fragment>
            <Script>{`
              // CNP validation code from earlier is now moved to the main script block
              // This block can be used for other functionality if needed
            `}</Script>
          </React.Fragment>
        </div>
      </div>
    </div>
  )
}

export default Formular230
